/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EmptyInvoicesTable from './icon-empty-invoices-table.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EmptyInvoicesTable {...validProps} />;
}
SvgComponent.iconName = 'emptyInvoicesTable';

export const EmptyInvoicesTableIcon = svgIconWrapper(SvgComponent);
